import { render, staticRenderFns } from "./ShareRegister.vue?vue&type=template&id=6aa86aee&scoped=true"
import script from "./ShareRegister.vue?vue&type=script&lang=ts"
export * from "./ShareRegister.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa86aee",
  null
  
)

export default component.exports